import React, { useEffect, useRef, useState, useCallback } from 'react';
import Table from '../components/Table';
import LeadService from '../core/services/leadsService';
import { useParams, useNavigate } from 'react-router-dom';
import { capitalizeFirstLetter } from '../core/helper';
import { Container, Box, Typography, Avatar, Button, Grid, CircularProgress } from '@mui/material';
import Card from '@mui/material/Card';
import CardHeader from '@mui/material/CardHeader';
import CardMedia from '@mui/material/CardMedia';
import CardContent from '@mui/material/CardContent';
import CardActions from '@mui/material/CardActions';
import { CardActionArea } from '@mui/material';
import logo_between from '../../public/assets/logo_between.png';
import Collapse from '@mui/material/Collapse';
import { Modal, IconButton, Pagination } from '@mui/material';
import { styled } from '@mui/material/styles';
import AdminIcaEdit from './AdminIcaEdit';
import Chart from 'chart.js/auto';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import toast from 'react-hot-toast';
import { format } from 'date-fns';
import Paper from '@mui/material/Paper';
import InputBase from '@mui/material/InputBase';
import SearchIcon from '@mui/icons-material/Search';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import LinearProgress from '@mui/material/LinearProgress';
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';
import { isInteger } from 'formik';
import { debounce, throttle } from 'lodash';
import { CircularProgressbar, buildStyles } from 'react-circular-progressbar';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import { makeStyles } from '@mui/styles';
import { useTheme } from '@mui/material/styles';
import ScrollAnimation from 'react-animate-on-scroll';
import { GlobalStyles } from '@mui/system';
import { ThemeProvider } from '@mui/material/styles';
import Agent from '../../public/statusImages/Agent.svg';
import AppointmentSet from '../../public/statusImages/AppointmentSet.svg';
import AttemptingContact from '../../public/statusImages/AttemptingContact.svg';
import BadLead from '../../public/statusImages/BadLead.svg';
import BamFam from '../../public/statusImages/BamFam.svg';
import Cancelled from '../../public/statusImages/Cancelled.svg';
import Closed from '../../public/statusImages/Closed.svg';
import MetWithCustomer from '../../public/statusImages/MetWithCustomer.svg';
import NotIntrested from '../../public/statusImages/NotIntrested.svg';
import NurtureBeforeSale from '../../public/statusImages/NurtureBeforeSale.svg';
import NurtureAfterSale from '../../public/statusImages/NurtureAfterSale.svg';
import PersonalLead from '../../public/statusImages/PersonalLead.svg';
import RefinanceReferral from '../../public/statusImages/RefinanceReferral.svg';
import Rejected from '../../public/statusImages/Rejected.svg';
import ShowingHomes from '../../public/statusImages/ShowingHomes.svg';
import SpokeWithCustomer from '../../public/statusImages/SpokeWithCustomer.svg';
import BuySideContract from '../../public/statusImages/BuySideContract.svg';
import New from '../../public/statusImages/New.svg';
import SubmittingOffers from '../../public/statusImages/SubmittingOffers.svg';
import UnderContract from '../../public/statusImages/UnderContract.svg';
import ListingUnderContract from '../../public/statusImages/ListUnderContract.svg';
import FollowUp from '../../public/statusImages/FollowUp.svg';
import ListingSigned from '../../public/statusImages/ListingSigned.svg';
// import Broker from '../../public/statusImages/BuyerBrokerSigned.svg';
import DNC from '../../public/statusImages/DNC.svg';
import BuyerBrokerSigned from '../../public/statusImages/BuyerBrokerSigned.svg';
import ValuationAppointment from '../../public/statusImages/ValuationAppointment.svg';
// import Assigned from '../../public/statusImages/Assigned.svg';
import ListingAppointment from '../../public/statusImages/ListingAppointment.svg';
import ListUnderContract from '../../public/statusImages/ListUnderContract.svg';
const useStyles = makeStyles((theme) => ({
    ICAAgentDetailMainBox: {
        display: 'flex',
        justifyContent: 'space-between',
        backgroundColor: 'white',
        padding: '16px',
        borderRadius: '22px',
        boxShadow: 'rgba(99, 99, 99, 0.2) 0px 2px 8px 0px',
        height: 'auto',
        [theme.breakpoints.down('md')]: {
            width: '1000px',
            display: 'flex',
            justifyContent: 'space-between',
            backgroundColor: 'white',
            padding: '16px',
            borderRadius: '22px',
            boxShadow: 'rgba(99, 99, 99, 0.2) 0px 2px 8px 0px',
            height: 'auto',
        },
    },
    ICAAgentDetailBio: {
        marginTop: '20px',
        padding: '20px',
        borderRadius: '22px',
        boxShadow: 'rgba(99, 99, 99, 0.2) 0px 2px 8px 0px',
        [theme.breakpoints.down('md')]: {
            marginTop: '20px',
            padding: '20px',
            borderRadius: '22px',
            boxShadow: 'rgba(99, 99, 99, 0.2) 0px 2px 8px 0px',
            width: '1000px',
        },
    },
    ICAAgentDetailAssignment: {
        mt: 2,
        maxHeight: '1000px',
        overflowY: 'hidden',
        borderRadius: '22px',
        boxShadow: 'rgba(99, 99, 99, 0.2) 0px 2px 8px 0px',
        [theme.breakpoints.down('md')]: {
            width: 1000,
            mt: 2,
            maxHeight: '1000px',
            overflowY: 'hidden',
            borderRadius: '22px',
            boxShadow: 'rgba(99, 99, 99, 0.2) 0px 2px 8px 0px',
        },
        [theme.breakpoints.between('md', 'xmd')]: {
            width: 'auto',
            mt: 2,
            maxHeight: '1000px',
            overflowY: 'hidden',
            borderRadius: '22px',
            boxShadow: 'rgba(99, 99, 99, 0.2) 0px 2px 8px 0px',
        },
    },
    ICAAssignmentDate: {
        width: '270px',
        [theme.breakpoints.down('md')]: {
            width: '150px',
        },
        [theme.breakpoints.between('md', 'xmd')]: {
            width: '150px',
        },
    },
    ICAAgentDetailsStatus: {
        width: 270,
        [theme.breakpoints.down('md')]: {
            width: '170px',
        },
        [theme.breakpoints.between('md', 'xmd')]: {
            width: '170px',
        },
    },
    ICAAgentDetailsAssignmentCard: {
        width: 193,
        height: 232,
        [theme.breakpoints.down('md')]: {
            width: 170,
            height: 232,
        },
        [theme.breakpoints.between('md', 'xmd')]: {
            width: 170,
            height: 232,
        },
    },
    fromToDateIcaAgentDetailsStyles: {
        display: 'flex',
        justifyContent: 'space-between',
        backgroundColor: 'white',
        padding: '16px',
        borderRadius: '22px',
        boxShadow: 'rgba(99, 99, 99, 0.2) 0px 2px 8px 0px',
        height: '150px',
        marginTop: '20px',
        marginBottom: '20px',
        [theme.breakpoints.down('md')]: {
            display: 'flex',
            justifyContent: 'space-between',
            backgroundColor: 'white',
            padding: '16px',
            borderRadius: '22px',
            boxShadow: 'rgba(99, 99, 99, 0.2) 0px 2px 8px 0px',
            height: '150px',
            marginTop: '20px',
            marginBottom: '20px',
            width: '1000px',
        },
    },
    AssignmentExpandFiltersICA: {
        width: 'auto',
        display: 'flex',
        gap: '10px',
        marginBottom: '3px',
        justifyContent: 'center',
        [theme.breakpoints.down('md')]: {
            width: 'auto',
            display: 'flex',
            gap: '10px',
            marginBottom: '3px',
            justifyContent: 'space-between',
        },
        [theme.breakpoints.between('md', 'xmd')]: {
            width: 'auto',
            display: 'flex',
            gap: '10px',
            marginBottom: '3px',
            justifyContent: 'space-between',
        },
    },
    chartRefIcaAgentDetailsStyles: {
        background: '#FFFFFF',
        borderRadius: '22px',
        boxShadow: 'rgba(99, 99, 99, 0.2) 0px 2px 8px 0px',
        marginTop: '10px',
        height: 490,
        [theme.breakpoints.down('md')]: {
            background: '#FFFFFF',
            borderRadius: '22px',
            boxShadow: 'rgba(99, 99, 99, 0.2) 0px 2px 8px 0px',
            marginTop: '10px',
            height: 490,
            width: '1000px',
        },
        [theme.breakpoints.between('md', 'xmd')]: {
            background: '#FFFFFF',
            borderRadius: '22px',
            boxShadow: 'rgba(99, 99, 99, 0.2) 0px 2px 8px 0px',
            marginTop: '10px',
            height: 490,
            width: 'auto',
        },
    },
    chartRefCardAgentDetailsStyles: {
        width: 'auto',
        marginTop: '25px',
        borderRadius: '22px',
        boxShadow: 'rgba(99, 99, 99, 0.2) 0px 2px 8px 0px',
        [theme.breakpoints.down('md')]: {
            width: '1000px',
            marginTop: '25px',
            borderRadius: '22px',
            boxShadow: 'rgba(99, 99, 99, 0.2) 0px 2px 8px 0px',
        },
    },
    chartRefDivAgentDetailsStyles: {
        width: '680px',
        height: '680px',
        marginTop: '20px',
        padding: '10px',
        [theme.breakpoints.down('md')]: {
            width: '580px',
            height: '680px',
            marginTop: '20px',
            padding: '10px',
        },
    },
    chartRefLineAgentDetailsStyles: {
        background: '#FFFFFF',
        borderRadius: '22px',
        boxShadow: 'rgba(99, 99, 99, 0.2) 0px 2px 8px 0px',
        marginTop: '10px',
        [theme.breakpoints.down('md')]: {
            background: '#FFFFFF',
            borderRadius: '22px',
            boxShadow: 'rgba(99, 99, 99, 0.2) 0px 2px 8px 0px',
            marginTop: '10px',
            width: '1000px',
        },
    },
    filtersMainDivStyle: {
        display: 'flex',
        justifyContent: 'space-between',
        backgroundColor: 'white',
        padding: '16px',

        height: '150px',
        marginTop: '20px',
        marginBottom: '20px',
        alignItems: 'center',
        gap: '25px',
        borderRadius: '22px',
        boxShadow: 'rgba(99, 99, 99, 0.2) 0px 2px 8px 0px',
        [theme.breakpoints.between('md', 'xmd')]: {
            display: 'flex',
            justifyContent: 'space-between',
            backgroundColor: 'white',
            padding: '16px',
            borderRadius: '22px',
            boxShadow: 'rgba(99, 99, 99, 0.2) 0px 2px 8px 0px',
            height: '150px',
            marginTop: '20px',
            marginBottom: '20px',
            alignItems: 'center',
            gap: '25px',
            width: '100%',
        },
    },
}));

const ExpandMore = styled((props) => {
    const { expand, ...other } = props;
    return <IconButton {...other} />;
})(({ theme, expand }) => ({
    marginLeft: 'auto',
    transition: theme.transitions.create('transform', {
        duration: theme.transitions.duration.shortest,
    }),
}));
const tableDefatultTextStyle = { fontWeight: 400, fontSize: '0.875rem' };

const ISAAgentsDetails = () => {
    let { id } = useParams();
    const navigate = useNavigate();
    const classes = useStyles();
    const theme = useTheme();
    const [ICAAgentsDetails, setICAAgentsDetails] = React.useState([]);
    const chartRefLine = useRef(null);
    const chartRefPai = useRef(null);
    const chartRef = useRef(null);
    const [chartData, setChartData] = React.useState(null);
    const [chartDataLine, setChartDataLine] = React.useState(null);
    const [statusOverview, setStatusOverview] = React.useState({});
    const [highestCount, setHighestCount] = React.useState();
    const [selectedUserId, setSelectedUserId] = React.useState(id);
    const [fromDate, setFromDate] = React.useState('');
    const [toDate, setToDate] = React.useState('');
    const [loading, setLoading] = React.useState(false);
    const [isLoadingDetails, setIsLoadingDetails] = React.useState(false);
    const [expandedAssignment, setExpandedAssignment] = React.useState(false);
    const [paiChartData, setPaiChartData] = React.useState();
    const [totalCountData, setTotalCountData] = React.useState();
    const [chartDataPie, setChartDataPie] = React.useState(null);
    const [assignmentDetails, setAssignmentDetails] = React.useState([]);
    const [currentPage, setCurrentPage] = React.useState(1);
    const [totalPages, setTotalPages] = React.useState(0);
    const [searchTerm, setSearchTerm] = useState('');
    const [availableAssignment, setAvailableAssignment] = useState([]);
    const [filtersData, setFilterData] = React.useState({});
    const [filters, setFilters] = useState({ status: '' });
    const [selectedStatus, setSelectedStatus] = useState(null);
    const [fromDate2, setFromDate2] = React.useState('');
    const [toDate2, setToDate2] = React.useState('');
    const [dateFilter, setdateFilter] = useState('');
    const abortControllerRef = useRef(null);

    const adjustTimeBasedOnOffsetForReceivedData = (dateString, offsetInHours) => {
        const date = new Date(dateString);
        // Convert to UTC and then apply offset
        const utcDate = new Date(date.getTime() + date.getTimezoneOffset() * 60000);
        utcDate.setHours(utcDate.getHours() + offsetInHours);
        return utcDate;
    };

    const getUserOffset = () => {
        const offset = localStorage.getItem('userOffset');
        return offset ? parseFloat(offset) : 0;
    };

    const formatDateTime = (date) => {
        const options = { year: 'numeric', month: 'long', day: '2-digit', hour: '2-digit', minute: '2-digit', hour12: true };
        return date.toLocaleDateString(undefined, options).replace(',', '');
    };
    const userOffset = getUserOffset();
    const adjustedDate = adjustTimeBasedOnOffsetForReceivedData(ICAAgentsDetails.created_at, userOffset);
    const formattedDate = formatDateTime(adjustedDate);

    const handleExpandAssignmentClick = () => {
        setExpandedAssignment(!expandedAssignment);
    };

    const getISAAgents = async (id) => {
        try {
            setIsLoadingDetails(true);
            const res = await LeadService.getIsaAgentDetailsApi(id);
            setIsLoadingDetails(false);
            if (res?.data?.success) {
                setICAAgentsDetails(res?.data?.data);
                return;
            }
        } catch (error) {
            toast.success(error?.message);
            console.error(error);
        } finally {
            setLoading(false);
        }
    };

    const handleClickSearchAssignment = async (searchTerm, filters) => {
        const currentDate = new Date();

        if (fromDate2 && new Date(fromDate2) > currentDate) {
            toast.error('Please select a from date not later than the current date.');
            return;
        }
        if (toDate2 && fromDate2 && new Date(toDate2) <= new Date(fromDate2)) {
            toast.error('Please select a to date later than the start date.');
            return;
        }
        // Check if toDate2 is in the future
        if (toDate2 && new Date(toDate2) > currentDate) {
            toast.error('Please select a to date not later than the current date.');
            return;
        }
        const formattedFromDate = fromDate2 ? formatDate(fromDate2) : null;
        const formattedToDate = toDate2 ? formatDate(toDate2) : null;
        const searchParam = {
            // user_id: selectedUserId,
            from_date: formattedFromDate,
            to_date: formattedToDate,
        };
        setdateFilter(searchParam);
        // await getAllAssignments(1, searchTerm, filters, searchParam);
    };

    const clearStateAssignment = () => {
        setFromDate2('');
        setToDate2('');
        setCurrentPage(1);
        setdateFilter('');
        setSearchTerm('');
        setFilters({ status: '' });
        setSelectedStatus(null);
        fetchAssignments();
    };

    const getAllAssignments = async (
        id,
        currentPage,
        searchTerm = '',
        filters = { status: '' },
        searchParam = { from_date: '', to_date: '' },
        signal
    ) => {
        try {
            setIsLoadingDetails(true);
            const res = await LeadService.getICAAAgentAssignmentApi(id, currentPage, searchTerm, filters, searchParam, { signal });

            if (res?.data?.success) {
                setIsLoadingDetails(false);
                setAvailableAssignment(res?.data);
                setAssignmentDetails(res?.data?.data.data || []);
                setCurrentPage(res?.data?.data?.current_page || 1);
                setTotalPages(Math.ceil((res?.data?.data?.total || 1) / (res?.data?.data?.per_page || 1)));
                return;
            }
        } catch (error) {
            toast.error(error?.message);
            console.error(error);
        } finally {
            setLoading(false);
        }
    };

    const throttledGetAllAssignments = useCallback(
        throttle((id, currentPage, searchTerm, filters, dateFilter, signal) => {
            getAllAssignments(id, currentPage, searchTerm, filters, dateFilter, signal);
        }, 2000),
        []
    );

    const fetchAssignments = useCallback(
        debounce((id, currentPage, searchTerm, filters, dateFilter) => {
            if (abortControllerRef.current) {
                abortControllerRef.current.abort();
            }
            const abortController = new AbortController();
            abortControllerRef.current = abortController;
            throttledGetAllAssignments(id, currentPage, searchTerm, filters, dateFilter, abortController.signal);
        }, 300),
        [throttledGetAllAssignments]
    );

    useEffect(() => {
        fetchAssignments(id, currentPage, searchTerm, filters, dateFilter);
    }, [id, currentPage, searchTerm, filters, dateFilter, fetchAssignments]);

    const handleSearchChange = (event) => {
        setSearchTerm(event.target.value);
        setCurrentPage(1);
    };

    const handleFilters = (value, name) => {
        setFilters((prev) => {
            const selectedValue = value === 'all' ? '' : value ? value.value : ''; // Use the original value for backend
            return {
                ...prev,
                [name]: selectedValue,
            };
        });
    };

    const transformText = (text) => {
        return text
            .split('_')
            .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
            .join(' ');
    };

    // Function to handle transformations for all arrays
    const transformData = (data) => {
        return data.map((item) => ({
            value: item,
            text: transformText(item),
        }));
    };

    const getLeadSearchData = async () => {
        try {
            const res = await LeadService.getLeadSearchDataApi();
            if (res?.data?.success) {
                const transformedStatuses = transformData(res.data.status);
                setFilterData({
                    ...res.data,
                    status: transformedStatuses,
                });
            }
        } catch (error) {
            console.error(error.message);
            toast.error(error.message);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        getLeadSearchData();
    }, []);

    const getStatusesOverview = async (id) => {
        try {
            setLoading(true);
            let searchParam;
            if (typeof id === 'string') {
                searchParam = { user_id: parseInt(id) };
            } else if (typeof id === 'object' && id.user_id) {
                searchParam = id;
            }

            const res = await LeadService.StatusesOverview(searchParam);
            if (res?.data?.success) {
                setStatusOverview(res?.data?.data);
                setHighestCount(res?.data?.highestCount);
                if (res?.data?.highestCount === 0) {
                    toast.success('No data found Status Change Overview!');
                }
                return res?.data?.data;
            }
        } catch (error) {
            console.error(error.message);
            toast.error(error.message);
        } finally {
            setLoading(false);
        }
    };

    const getPaiChartLeadStatus = async (id) => {
        try {
            setLoading(true);
            const res = await LeadService.GetLeadsCountByStatus(id);
            if (res?.data?.success) {
                setPaiChartData(res?.data?.leadsCount);
                setTotalCountData(res?.data?.totalLeadsCount);
            }
        } catch (error) {
            console.error(error.message);
            toast.error(error.message);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        getISAAgents(id);
        getStatusesOverview(id);
        getPaiChartLeadStatus(id);
    }, []);

    const formatDate = (dateString) => {
        const date = new Date(dateString);
        const day = date.getDate().toString().padStart(2, '0');
        const month = (date.getMonth() + 1).toString().padStart(2, '0');
        const year = date.getFullYear().toString();
        return `${day}-${month}-${year}`;
    };

    const handleSearchClick = async () => {
        // if (!selectedUserId) {
        //     toast.error('Please select any employee before searching.');
        //     return;
        // }
        const currentDate = new Date();

        if (fromDate && new Date(fromDate) > currentDate) {
            toast.error('Please select a from date not later than the current date.');
            return;
        }
        if (toDate && fromDate && new Date(toDate) <= new Date(fromDate)) {
            toast.error('Please select a to date later than the start date.');
            return;
        }
        if (toDate && new Date(toDate) > currentDate) {
            toast.error('Please select a to date not later than the current date.');
            return;
        }
        const formattedFromDate = fromDate ? formatDate(fromDate) : null;
        const formattedToDate = toDate ? formatDate(toDate) : null;
       
        const searchParam = {
            user_id: selectedUserId,
            from_date: formattedFromDate,
            to_date: formattedToDate,
        };

        const newData = await getStatusesOverview(searchParam);
        if (newData) {
            // Update the chart data with the new data
            setChartData((prevChartData) => ({
                ...prevChartData,
                datasets: [
                    {
                        ...prevChartData.datasets[0],
                        data: [
                            newData.appointment_set,
                            newData.met_with_customer,
                            newData.showing_homes,
                            newData.submitting_offers,
                            newData.under_contract_escrow,
                            newData.bamfam,
                            newData.nurture,
                            newData.closed,
                            newData.nurture_after_sale,
                            newData.rejected,
                        ],
                    },
                ],
            }));
        }
    };

    const clearState = () => {
        setFromDate('');
        setToDate('');
        getStatusesOverview(id);
    };

    // line chart
    useEffect(() => {
        const initialDataLine = {
            labels: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
            datasets: [
                {
                    label: 'Data',
                    data: [10, 40, 70, 60, 70, 80, 40, 80, 20, 60, 50, 40],
                },
            ],
        };

        setChartDataLine(initialDataLine);
    }, []);

    useEffect(() => {
        if (chartDataLine && chartRefLine.current) {
            const ctxLine = chartRefLine.current.getContext('2d');

            const options = {
                plugins: {
                    datalabels: {
                        color: 'black',
                        anchor: 'end',
                        align: 'end',
                        formatter: (value, context) => value,
                        font: {
                            weight: 'bold',
                            size: 12,
                        },
                    },
                    tooltip: {
                        mode: 'index',
                        intersect: false,
                        displayColors: false,
                        callbacks: {
                            label: function (context) {
                                var label = context.dataset.label || '';
                                if (label) {
                                    label += ': ';
                                }
                                if (context.parsed.y !== null) {
                                    label += context.parsed.y;
                                }
                                return label;
                            },
                        },
                        bodyFontColor: function (context) {
                            var dataset = context.dataset;
                            var index = context.dataIndex;
                            var value = dataset.data[index];
                            return dataset.backgroundColor[index];
                        },
                    },
                    legend: {
                        display: false,
                        position: 'top',
                        labels: {
                            font: {
                                size: 16,
                                weight: 'bold',
                            },
                        },
                    },
                    title: {
                        display: true,
                        text: 'Score',
                        position: 'top',
                        align: 'start',
                        font: {
                            size: 20,
                            weight: 'bold',
                        },
                        padding: 20,
                    },
                },
                scales: {
                    y: {
                        min: 0,
                        max: 100,
                    },
                    x: {
                        grid: {
                            display: false,
                        },
                    },
                },
                layout: {
                    padding: {
                        left: 40,
                        right: 40,
                        top: 10,
                        bottom: 20,
                    },
                },
                responsive: true,
            };
            const gradient = ctxLine.createLinearGradient(0, 0, 0, 400);
            gradient.addColorStop(0, 'rgba(0, 128, 0, 1)'); // Dark green color near the line
            gradient.addColorStop(1, 'rgba(144, 238, 144, 0.3)'); // Light green color below

            options.elements = {
                line: {
                    fill: 'start',
                    backgroundColor: gradient,
                    borderColor: 'green',
                    borderWidth: 2,
                },
            };
            const myChartLine = new Chart(ctxLine, {
                type: 'line',
                data: chartDataLine,
                options: options,
            });

            return () => {
                myChartLine.destroy();
            };
        }
    }, [chartDataLine]);

    //Bar Chart
    useEffect(() => {
        const initialData = {
            labels: [
                'Appointment Set',
                'Met With Customer',
                'Showing Homes',
                'Submitting Offers',
                'Under Contract',
                'BAMFAM',
                'Nurture Before Sale',
                'Sale Closed',
                'Nurture After Sale',
                'Rejected',
            ],

            datasets: [
                {
                    label: 'Highest Value',
                    data: [
                        statusOverview?.appointment_set || 0,
                        statusOverview?.met_with_customer || 0,
                        statusOverview?.showing_homes || 0,
                        statusOverview?.submitting_offers || 0,
                        statusOverview?.under_contract_escrow || 0,
                        statusOverview?.bamfam || 0,
                        statusOverview?.nurture || 0,
                        statusOverview?.closed || 0,
                        statusOverview?.nurture_after_sale || 0,
                        statusOverview?.rejected || 0,
                    ],
                    backgroundColor: ['#00BF2A', '#7400C2', '#ED7DB1', '#6EA478', '#4C489B', '#6691CB', '#FDCA40', '#F17105', '#9B5B5B', '#ED0423'],
                    borderWidth: 0,
                    borderRadius: 18,
                    categoryPercentage: 0.7,
                },
            ],
        };

        setChartData(initialData);
    }, [statusOverview]);

    useEffect(() => {
        if (chartData && chartRef.current) {
            Chart.defaults.font.size = 10;
            Chart.defaults.font.weight = 'bold';
            const myChart = new Chart(chartRef.current, {
                type: 'bar',
                data: chartData,
                options: {
                    plugins: {
                        datalabels: {
                            color: 'black',
                            anchor: 'end',
                            align: 'end',
                            formatter: (value, context) => value,
                            font: {
                                weight: 'bold',
                                size: 12,
                            },
                        },
                        tooltip: {
                            mode: 'index',
                            intersect: false,
                            displayColors: false,
                            callbacks: {
                                label: function (context) {
                                    var label = context.dataset.label || '';
                                    if (label) {
                                        label += ': ';
                                    }
                                    if (context.parsed.y !== null) {
                                        label += context.parsed.y;
                                    }
                                    return label;
                                },
                            },
                            bodyFontColor: function (context) {
                                var dataset = context.dataset;
                                var index = context.dataIndex;
                                var value = dataset.data[index];
                                return dataset.backgroundColor[index];
                            },
                        },
                        legend: {
                            display: false,
                            position: 'top',
                            labels: {
                                font: {
                                    size: 16,
                                    weight: 'bold',
                                },
                            },
                        },
                        title: {
                            display: true,
                            text: 'Status Change Overview',
                            position: 'top',
                            align: 'start',
                            font: {
                                size: 20,
                                weight: 'bold',
                            },
                            padding: 20,
                        },
                    },
                    scales: {
                        y: {
                            beginAtZero: false,
                            min: 0,
                            max: highestCount || 100,
                        },
                        x: {
                            grid: {
                                display: false,
                            },
                        },
                    },
                    layout: {
                        padding: {
                            left: 30,
                            right: 30,
                            top: 10,
                            bottom: 10,
                        },
                    },
                    responsive: true,
                    maintainAspectRatio: false,
                },
                plugins: [ChartDataLabels],
            });

            return () => {
                myChart.destroy();
            };
        }
    }, [chartData]);

    //pie Chart colors
    let backgroundColors = {
        Agent: '#121212',
        'Appointment Set': '#00BF2A',
        'Attempting Contact': '#7400C2',
        'Bad Lead': '#ED7DB1',
        BAMFAM: '#6EA478',
        Cancelled: '#4C489B',
        Closed: '#6691CB',
        'Met with customer': '#0E4B37',
        'Not Interested': '#FEB065',
        'Nurture Before Sale': '#9B5B5B',
        'Nurture After Sale': '#DA5151',
        'Personal Lead': '#FEFE00',
        'Refinance Referral': '#008E6C',
        Rejected: '#7C0083',
        'Showing  Homes': '#F032E6',
        'Spoke with Customer': '#0000FE',
        'Buy Side Contract': '#FE4C00',
        New: '#FFC107',
        'Submitting Offers': '#00FE00',
        'Under Contract': '#AAFFC3',
        'Listing Under Contract': '#950E3F',
        'Follow Up': '#469990',
        'Listing Signed': '#C29800',
        Broker: '#FF0058',
        DNC: '#A87BFF',
        'Buyer Broker Signed': '#FABED4',
        'Valuation Apointment': '#7D9B00',
        Assigned: '#00FBFE',
        'Listing Appointment': '#CB5935',
    };
    let circleProgressColors = {
        'Agent': '#121212',
        'Appointment Set': '#00bf2aa1',
        'Attempting Contact': '#7400c2a8',
        'Bad Lead': '#ed7db18a',
        'BAMFAM': '#6ea478b8',
        Cancelled: '#4c489bb0',
        'Closed': '#6691cbcf',
        'Met with customer': '#0e4b37d1',
        'Not Interested': '#FEB065',
        'Nurture Before Sale': '#9B5B5B',
        'Nurture After Sale': '#da5151d9',
        'Personal Lead': '#fefe009e',
        'Refinance Referral': '#008e6cb5',
        'Rejected': '#7c0083b0',
        'Showing  Homes': '#F032E6',
        'Spoke with Customer': '#0000fe85',
        'Buy Side Contract': '#fe4c00ad',
        'New': '#ffc107bd',
        'Submitting Offers': '#53eb53d6',
        'Under Contract': '#AAFFC3',
        'Listing Under Contract': '#950E3F',
        'Follow Up': '#469990d6',
        'Listing Signed': '#c29800c2',
        'Broker': '#FF0058',
        'DNC': '#A87BFF',
        'Buyer Broker Signed': '#FABED4',
        'Valuation Apointment': '#7D9B00',
        'Assigned': '#00FBFE',
        'Listing Appointment': '#cb5935c9',
    };
    let statusLabelColors ={
        'Agent': '#121212',
        'Appointment Set': '#00bf2aa1',
        'Attempting Contact': '#7400c2a8',
        'Bad Lead': '#ed7db18a',
        'BAMFAM': '#6ea478b8',
        Cancelled: '#4c489bb0',
        Closed: '#6691cbcf',
        'Met with customer': '#0e4b37d1',
        'Not Interested': '#FEB065',
        'Nurture Before Sale': '#9B5B5B',
        'Nurture After Sale': '#da5151d9',
        'Personal Lead': '#c3c331',
        'Refinance Referral': '#008e6cb5',
        Rejected: '#7c0083b0',
        'Showing  Homes': '#F032E6',
        'Spoke with Customer': '#0000fe85',
        'Buy Side Contract': '#fe4c00ad',
        New: '#ffc107bd',
        'Submitting Offers': '#53eb53d6',
        'Under Contract': '#6fdb8f',
        'Listing Under Contract': '#950E3F',
        'Follow Up': '#469990d6',
        'Listing Signed': '#c29800c2',
        Broker: '#FF0058',
        DNC: '#A87BFF',
        'Buyer Broker Signed': '#FABED4',
        'Valuation Apointment': '#7D9B00',
        Assigned: '#00FBFE',
        'Listing Appointment': '#cb5935c9',
    }
    const statusImages = {
        Agent: Agent,
        'Appointment Set': AppointmentSet,
        'Attempting Contact': AttemptingContact,
        'Bad Lead': BadLead,
        BAMFAM: BamFam,
        Cancelled: Cancelled,
        Closed: Closed,
        'Met with customer': MetWithCustomer,
        'Not Interested': NotIntrested,
        'Nurture Before Sale': NurtureBeforeSale,
        'Nurture After Sale': NurtureAfterSale,
        'Personal Lead': PersonalLead,
        'Refinance Referral': RefinanceReferral,
        Rejected: Rejected,
        'Showing Homes': ShowingHomes,
        'Spoke with Customer': SpokeWithCustomer,
        'Buy Side Contract': BuySideContract,
        New: New,
        'Submitting Offers': SubmittingOffers,
        'Under Contract': UnderContract,
        'Listing Under Contract': ListingUnderContract,
        'Follow Up': FollowUp,
        'Listing Signed': ListingSigned,
        // Broker: Broker,
        DNC: DNC,
        'Buyer Broker Signed': BuyerBrokerSigned,
        'Valuation Appointment': ValuationAppointment,
        // Assigned: Assigned,
        'Listing Appointment': ListingAppointment,
        'List Under Contract': ListUnderContract,
    };
    const percentages = paiChartData?.map((lead) => {
        const percentage = (lead.status_count / totalCountData) * 100;
        const formattedPercentage = percentage.toFixed(2);
        return formattedPercentage;
    });

    useEffect(() => {
        const labels = paiChartData?.map((lead) => lead.status);
        const chartData = paiChartData?.map((lead) => lead.status_count);
        const backgroundColor = labels?.map((label) => backgroundColors[label]);

        const initialData = {
            labels: labels,
            datasets: [
                {
                    data: chartData,
                    backgroundColor: backgroundColor,
                    borderColor: 'white',
                    // borderRadius: 1,
                    borderWidth: 1,
                },
            ],
        };

        setChartDataPie(initialData);
    }, [paiChartData]);

    useEffect(() => {
        if (chartDataPie && chartRefPai.current) {
            Chart.defaults.font.size = 12;
            Chart.defaults.font.weight = 'bold';
            const myChart = new Chart(chartRefPai.current, {
                type: 'pie',
                data: chartDataPie,
                options: {
                    plugins: {
                        legend: {
                            display: false,
                        },
                        title: {
                            display: true,
                            text: 'Agent Leads Overview',
                            position: 'top',
                            align: 'start',
                            font: {
                                size: 20,
                                weight: 'bold',
                            },
                            padding: 20,
                        },
                        datalabels: {
                            color: 'black',
                            anchor: 'end',
                            align: 'end',
                            formatter: (value, context) => value,
                            font: {
                                weight: 'bold',
                                size: 12,
                            },
                        },
                    },
                    tooltip: {
                        mode: 'index',
                        intersect: false,
                        displayColors: false,
                        callbacks: {
                            label: function (context) {
                                var label = context.dataset.label || '';
                                if (label) {
                                    label += ': ';
                                }
                                if (context.parsed.y !== null) {
                                    label += context.parsed.y;
                                }
                                return label;
                            },
                        },
                        bodyFontColor: function (context) {
                            var dataset = context.dataset;
                            var index = context.dataIndex;
                            var value = dataset.data[index];
                            return dataset.backgroundColor[index];
                        },
                    },
                    layout: {
                        padding: {
                            left: 30,
                            right: 30,
                            top: 10,
                            bottom: 10,
                        },
                    },
                    responsive: true,
                    maintainAspectRatio: false,
                },
            });

            return () => {
                myChart.destroy();
            };
        }
    }, [chartDataPie]);

    const statusDisplay = {
        new: { text: ' ● New ', color: '#00000F', border: '1px solid black', background: '#e9e4e4' },
        spoke_with_customer: { text: ' ● Spoke With Customer ', color: '#00000F', border: '1px solid #00000F', background: '#ababef' },
        active: { text: ' ● New ', color: '#00000F', border: '1px solid black', background: '#e9e4e4' },
        attempting_contact: { text: ' ● Attempting Contact ', color: '#9B0000', border: '1px solid #9B0000', background: '#ababef' },
        spoke_with_customer_new: { text: ' ● New ', color: '#00000F', border: '1px solid #00000F', background: '#ababef' },
        appointment_set: { text: ' ● Appointment Set ', color: '#00BF2A', border: '1px solid #00BF2A', background: '#bee5c6' },
        met_with_customer: { text: ' ● Met with customer ', color: '#7400C2', border: '1px solid #7400C2', background: '#d9c2e9' },
        showing_homes: { text: ' ● Showing Homes ', color: '#ED7DB1', border: '1px solid #ED7DB1', background: '#f9d5e6' },
        submitting_offers: { text: ' ● Submitting Offers ', color: '#6EA478', border: '1px solid #6EA478', background: '#bbe3c2' },
        under_contract_escrow: { text: ' ● Under Contract ', color: '#4C489B', border: '1px solid #4C489B', background: '#c1bfed' },
        bamfam: { text: ' ● BAMFAM ', color: '#6691CB', border: '1px solid #6691CB', background: '#edeff5' },
        nurture: { text: ' ● Nurture Before Sale ', color: '#9B5B00', border: '1px solid #9B5B00', background: '#f9deb8' },
        closed: { text: ' ● Sale Closed ', color: '#F17105', border: '1px solid #F17105', background: '#fff0e3' },
        nurture_after_sale: { text: ' ● Nurture After Sale ', color: '#9B5B5B', border: '1px solid #9B5B5B', background: '#e7c612' },
        rejected: { text: ' ● Rejected ', color: '#ED0423', border: '1px solid #ED0423', background: '#fbdfe2' },
        not_interested: { text: ' ● Not Interested ', color: '#9B5B5B', border: '1px solid #9B5B5B', background: '#e7c612' },
        bad_lead: { text: ' ● Bad Lead ', color: '#572ab2', border: '1px solid #223d9e', background: '#fbdfe2' },
        cancelled: { text: ' ● Cancelled ', color: '#ED0423', border: '1px solid #ED0423', background: '#fbdfe2' },
        refinance_referral: { text: ' ● Refinance Referral ', color: '#9B5B5B', border: '1px solid #9B5B5B', background: '#12c3e7' },
        dnc: { text: ' ● DNC ', color: '#9B5B5B', border: '1px solid #9B5B5B', background: '#A87BFF' },
        buyer_broker_signed: { text: ' ● Buyer Broker Signed ', color: '#9B5B5B', border: '1px solid #9B5B5B', background: '#FABED4' },
        agent: { text: ' ● Agent ', color: '#9B5B5B', border: '1px solid #9B5B5B', background: '#FABED4' },
        valuation_appointment: { text: ' ● Valuation Appointment ', color: '#9B5B5B', border: '1px solid #9B5B5B', background: '#7D9B00' },
        assigned: { text: ' ● Assigned', color: '#9B5B5B', border: '1px solid #9B5B5B', background: '#00FBFE' },
        listing_appointment: { text: ' ● Listing Appointment', color: '#9B5B5B', border: '1px solid #9B5B5B', background: '#CB5935' },
        personal_lead: { text: ' ● Personal Lead', color: '#9B5B5B', border: '1px solid #9B5B5B', background: '#FEFE00' },
        buy_side_contract: { text: ' ● Buy Side Contract', color: '#9B5B5B', border: '1px solid #9B5B5B', background: '#e7c612' },
        listing_signed: { text: ' ●Listing Signed', color: '#FFFFFF', border: '1px solid #483c10', background: '#C29800' },
        follow_up: { text: ' Follow Up ', color: '#FFFFFF', border: '1px solid #2d6f55', background: '#2e7a5c' },
    };

    const highlightText = (text, highlight) => {
        if (!text) return null;
        if (!highlight) return text;
        const regex = new RegExp(`(${highlight})`, 'gi');
        const parts = text.split(regex);
        return (
            <>
                {parts?.map((part, index) =>
                    part.toLowerCase() === highlight.toLowerCase() ? (
                        <span key={index} style={{ color: '#ee9a24' }}>
                            {part}
                        </span>
                    ) : (
                        part
                    )
                )}
            </>
        );
    };
    const handlePageChange = (event, value) => {
        setCurrentPage(value);
    };
    const HandleBackNavigate = () => {
        navigate('/ica-agents');
    };
    const handleNavigateLeadDetailsPage = (id) => {
        const UserType = ICAAgentsDetails?.user_type;
        const UserId = ICAAgentsDetails?.id;
        navigate(`/admin-leads-details/${id}`, { state: { UserType: UserType, UserId: UserId } });
    };
    let backgroundColorsCard = {
        'Agent': '#3e3e3e3d',
        'Appointment Set': '#23f95269',
        'Attempting Contact': '#6204a142',
        'Bad Lead': '#fd60a94a',
        'BAMFAM': '#6ea47869',
        'Cancelled': '#4c489b36',
        'Closed': '#6691cb45',
        'Met with customer': '#0e4b3770',
        'Not Interested': '#feb06569',
        'Nurture Before Sale': '#9b5b5b4d',
        'Nurture After Sale': '#da51515e',
        'Personal Lead': '#d9d9155c',
        'Refinance Referral': '#008e6c82',
        'Rejected': '#7c008352',
        'Showing  Homes': '#f032e657',
        'Spoke with Customer': '#0000fe45',
        'Buy Side Contract': '#fe4c0063',
        'New': '#c59a1870',
        'Submitting Offers': '#00fe0047',
        'Under Contract': '#256c398f',
        'Listing Under Contract': '#8d828226',
        'Follow Up': '#46999042',
        'Listing Signed': '#c298004f',
        'Broker': '#c59a1870',
        'DNC': '#a87bff4d',
        'Buyer Broker Signed': '#f786b047',
        'Valuation Apointment': '#7d9b0075',
        'Assigned': '#00FBFE',
        'Listing Appointment': '#cb593557',
        'List Under Contract': '#5c2e2e9c',

    };
    return (
        <>
            <div style={{ marginBottom: '15px' }}> {isLoadingDetails && <LinearProgress />}</div>
            <Box>
                <Button onClick={HandleBackNavigate}
                sx={{background: '#efefef', marginBottom:'12px', marginLeft: '22px', padding: '6px', '&:hover': {background: '#cecaca'},}}> 
                <ArrowBackIosIcon style={{ color: '#8f7f7f', marginLeft: '6px' }} />
                </Button>
            </Box>

            <Container>
                <ThemeProvider theme={theme}>
                    <GlobalStyles
                        styles={{
                            '::-webkit-scrollbar': {
                                width: '14px', // Set the desired width for the scrollbar
                            },
                            '::-webkit-scrollbar-thumb': {
                                backgroundColor: '#c1c1c1', // Set the color for the scrollbar thumb
                                borderRadius: '10px', // Set the border radius for a rounded effect
                            },
                        }}
                    />
                    <ScrollAnimation animateIn="fadeIn">
                        <Box className={classes.ICAAgentDetailMainBox}>
                            <Box style={{ display: 'flex' }}>
                                <div>
                                    <Avatar
                                        alt={ICAAgentsDetails?.name}
                                        src={`https://iconnctapp.com/` + ICAAgentsDetails?.profile_image}
                                        sx={{ mr: 2, width: 100, height: 100 }}
                                    />
                                </div>

                                <div style={{ display: 'grid', alignContent: 'center', marginBottom: '22px', gap: '5px' }}>
                                    <div>
                                        <Typography style={{ fontWeight: 'bold' }}>
                                            {ICAAgentsDetails?.name} {ICAAgentsDetails?.last_name}
                                        </Typography>
                                    </div>
                                    <div>
                                        {ICAAgentsDetails.length === 0 ? null : (
                                            <Typography style={{ color: '#a8a0a0' }}>Member Since: {formattedDate}</Typography>
                                        )}
                                    </div>
                                    {ICAAgentsDetails.device_model === null || ICAAgentsDetails.app_version === null ? null : (
                                        <div>
                                            <Typography style={{ color: '#a8a0a0' }}>
                                                Device Model:{' '}
                                                <span style={{ fontWeight: 'bold' }}>
                                                    {ICAAgentsDetails?.device_model} {'  '} ,{' '}
                                                </span>
                                                Os Version:{' '}
                                                <span style={{ fontWeight: 'bold' }}>
                                                    {ICAAgentsDetails?.os_version} {'  '} ,{' '}
                                                </span>
                                                App Version: <span style={{ fontWeight: 'bold' }}>{ICAAgentsDetails?.app_version} </span>
                                            </Typography>
                                        </div>
                                    )}
                                    <div>
                                        <Typography>
                                            Score: <span style={{ fontWeight: 'bold' }}>73% </span>Quota:{' '}
                                            <span style={{ fontWeight: 'bold' }}>9/22</span>
                                        </Typography>
                                    </div>
                                </div>
                            </Box>
                            <Box style={{ marginTop: '38px', marginRight: '32px' }}>
                                <AdminIcaEdit
                                    name={ICAAgentsDetails?.name}
                                    last_name={ICAAgentsDetails?.last_name}
                                    email={ICAAgentsDetails?.email}
                                    id={ICAAgentsDetails?.id}
                                    phone={ICAAgentsDetails?.phone}
                                    getISAAgents={getISAAgents}
                                    bio={ICAAgentsDetails?.bio}
                                    image={ICAAgentsDetails?.profile_image}
                                />
                            </Box>
                        </Box>
                        {ICAAgentsDetails?.bio === null ? null : (
                            <Card className={classes.ICAAgentDetailBio} style={{borderRadius:'22px', boxShadow: 'rgba(99, 99, 99, 0.2) 0px 2px 8px 0px'}}>
                                <div>
                                    <Typography style={{ fontWeight: 'bold', fontSize: '18px' }}>Bio</Typography>
                                </div>
                                <div>
                                    <Typography>
                                        <span>{ICAAgentsDetails?.bio}</span>
                                    </Typography>
                                </div>
                            </Card>
                        )}
                        <ScrollAnimation animateIn="fadeIn">
                            {availableAssignment?.message === 'No Record Exists.' ? null : (
                                <>
                                    <Box style={{ display: 'flex', margin: '5px' }}>
                                        <Typography
                                            style={{
                                                fontSize: '25px',
                                                fontWeight: '700',
                                                color: '#414D55',
                                            }}
                                        >
                                            Assignments
                                        </Typography>
                                    </Box>

                                    <Box className={classes.AssignmentExpandFiltersICA}>
                                        {expandedAssignment && (
                                            <>
                                                <Box className={classes.filtersMainDivStyle}>
                                                    <Box
                                                        sx={{
                                                            p: '9px',
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                            width: 200,
                                                            background: '#F0F4F8',
                                                            marginTop: '30px',
                                                            borderRadius: '8px',
                                                        }}
                                                    >
                                                        <IconButton type="button" sx={{ p: '2px' }} aria-label="search">
                                                            <SearchIcon />
                                                        </IconButton>
                                                        <InputBase
                                                            sx={{
                                                                ml: 1,
                                                                flex: 1,
                                                                '& .MuiOutlinedInput-root': {
                                                            borderRadius: '12px',
                                                        },
                                                            }}
                                                            value={searchTerm}
                                                            onChange={handleSearchChange}
                                                            placeholder="Search by name"
                                                            inputProps={{ 'aria-label': 'search google maps' }}
                                                        />
                                                    </Box>
                                                    <Box style={{ marginTop: '30px' }}>
                                                        <Autocomplete
                                                            value={selectedStatus || null}
                                                            onChange={(event, value) => {
                                                                if (!value) {
                                                                    setSelectedStatus(null);
                                                                    setCurrentPage(1);
                                                                    fetchAssignments();
                                                                    setFilters((prevFilters) => ({ ...prevFilters, status: '' }));
                                                                } else {
                                                                    setSelectedStatus(value);
                                                                    handleFilters(value, 'status');
                                                                }
                                                            }}
                                                            options={filtersData.status || []}
                                                            getOptionLabel={(option) => option.text}
                                                            renderInput={(params) => <TextField {...params} label="Search by status" />}
                                                            className={classes.ICAAgentDetailsStatus}
                                                            disabled={loading}
                                                            sx={{'& .MuiOutlinedInput-root': {
                                                                borderRadius: '12px',
                                                            },}}
                                                        />
                                                    </Box>
                                                    <Box>
                                                        <Typography sx={{ fontWeight: 'bold' }}>From</Typography>
                                                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                            <DemoContainer components={['DatePicker', 'DesktopDatePicker']}>
                                                                <DesktopDatePicker
                                                                    className={classes.ICAAssignmentDate}
                                                                    sx={{
                                                                        overflow: 'hidden',
                                                                        '.MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
                                                                            borderColor: '#c1c1c1',
                                                                        },
                                                                        '.MuiOutlinedInput-root.Mui-error .MuiOutlinedInput-notchedOutline': {
                                                                            borderColor: '#c1c1c1',
                                                                        },'& .MuiOutlinedInput-root': {
                                                                            borderRadius: '12px',
                                                                        },
                                                                    }}
                                                                    value={fromDate2}
                                                                    onChange={(newDate) => setFromDate2(newDate)}
                                                                />
                                                            </DemoContainer>
                                                        </LocalizationProvider>
                                                    </Box>
                                                    <Box>
                                                        <Typography sx={{ fontWeight: 'bold' }}>To</Typography>
                                                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                            <DemoContainer components={['DatePicker', 'DesktopDatePicker']}>
                                                                <DesktopDatePicker
                                                                    className={classes.ICAAssignmentDate}
                                                                    sx={{
                                                                        overflow: 'hidden',
                                                                        '.MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
                                                                            borderColor: '#c1c1c1',
                                                                        },
                                                                        '.MuiOutlinedInput-root.Mui-error .MuiOutlinedInput-notchedOutline': {
                                                                            borderColor: '#c1c1c1',
                                                                        },'& .MuiOutlinedInput-root': {
                                                                            borderRadius: '12px',
                                                                        },
                                                                    }}
                                                                    value={toDate2}
                                                                    onChange={(newDate) => setToDate2(newDate)}
                                                                />
                                                            </DemoContainer>
                                                        </LocalizationProvider>
                                                    </Box>
                                                    <Box style={{ display: 'flex', alignItems: 'center', marginTop: '30px' }}>
                                                        <Box
                                                            style={{
                                                                width: '56px',
                                                                height: '50px',
                                                                background: '#336a93',
                                                                cursor: 'pointer',
                                                                borderRadius: '10px',
                                                                display: 'flex',
                                                                justifyContent: 'center',
                                                                alignItems: 'center',
                                                            }}
                                                            onClick={() => handleClickSearchAssignment(searchTerm, filters)}
                                                        >
                                                            {loading ? (
                                                                <CircularProgress sx={{ color: 'white' }} />
                                                            ) : (
                                                                <SearchIcon
                                                                    style={{
                                                                        color: 'white',
                                                                        fontSize: '41px',
                                                                        cursor: 'pointer',
                                                                    }}
                                                                />
                                                            )}
                                                        </Box>
                                                        <Button
                                                            style={{
                                                                width: '50px',
                                                                border: '1px solid gray',
                                                                background: 'transparent',
                                                                borderRadius: '8px',
                                                                fontWeight: 'bold',
                                                                marginLeft: '5px',
                                                                cursor: 'pointer',
                                                                marginBottom: 'px',
                                                            }}
                                                            onClick={clearStateAssignment}
                                                        >
                                                            clear
                                                        </Button>
                                                    </Box>
                                                </Box>
                                            </>
                                        )}
                                    </Box>

                                    <Card
                                        style={{ borderRadius: '22px', boxShadow: 'rgba(99, 99, 99, 0.2) 0px 2px 8px 0px', }}
                                        className={classes.ICAAgentDetailAssignment}
                                    >
                                        <CardActions disableSpacing style={{ display: 'flex', justifyContent: 'flex-end' }}>
                                            <Box>
                                                {assignmentDetails?.length >= 5 && (
                                                    <>
                                                        <ExpandMore
                                                            expand={expandedAssignment}
                                                            onClick={handleExpandAssignmentClick}
                                                            aria-expanded={expandedAssignment}
                                                            aria-label="show more"
                                                        >
                                                            <Typography
                                                                style={{
                                                                    color: '#5379BD',
                                                                    fontSize: '16px',
                                                                    fontWeight: '700',
                                                                    display: 'flex',
                                                                    justifyContent: 'flex-end',
                                                                }}
                                                            >
                                                                {expandedAssignment ? 'View Less' : 'View More'}
                                                            </Typography>
                                                        </ExpandMore>
                                                    </>
                                                )}
                                            </Box>
                                        </CardActions>
                                        <Box>
                                            {!expandedAssignment && (
                                                <Box
                                                    style={{
                                                        display: 'flex',
                                                        justifyContent: 'center',
                                                    }}
                                                >
                                                    {assignmentDetails?.length > 0 ? (
                                                        assignmentDetails?.slice(0, 5)?.map((leads, index) => (
                                                            <CardContent key={index} onClick={() => handleNavigateLeadDetailsPage(leads?.lead_id)}>
                                                                <Card
                                                                    style={{
                                                                        transform: 'scale(1)',
                                                                        transition: 'transform 0.3s ease-in-out',
                                                                        borderRadius: '22px',
                                                                        boxShadow: 'rgba(99, 99, 99, 0.2) 0px 2px 8px 0px',
                                                                        cursor: 'pointer',
                                                                    }}
                                                                    onMouseEnter={(e) => (e.currentTarget.style.transform = 'scale(1.05)')}
                                                                    onMouseLeave={(e) => (e.currentTarget.style.transform = 'scale(1)')}
                                                                    className={classes.ICAAgentDetailsAssignmentCard}
                                                                    key={index}
                                                                >
                                                                    <CardActionArea>
                                                                        <div style={{ position: 'relative' }}>
                                                                            <div
                                                                                style={{
                                                                                    position: 'absolute',
                                                                                    top: '53px',
                                                                                    left: '50%',
                                                                                    transform: 'translateX(-50%)',
                                                                                    zIndex: 10,
                                                                                    display: 'flex',
                                                                                    alignItems: 'center',
                                                                                    borderRadius: '4px',
                                                                                    padding: '5px',
                                                                                }}
                                                                            >
                                                                                <img
                                                                                    src={logo_between}
                                                                                    alt=""
                                                                                    style={{ width: '44px', height: '44px' }}
                                                                                />
                                                                            </div>
                                                                        </div>

                                                                        <img
                                                                            src={`https://maps.googleapis.com/maps/api/staticmap?zoom=13&size=450x200&maptype=roadmap&center=${leads?.lead?.buyer_latitude},${leads?.lead?.buyer_longitude}&key=AIzaSyC9saN_UXZFij-RjWWX9drQEQSZw5PaPcA`}
                                                                            alt=""
                                                                            style={{
                                                                                width: '470px',
                                                                                height: '120px',
                                                                                borderRadius: '10px',
                                                                            }}
                                                                        />

                                                                        <CardContent>
                                                                            <Typography
                                                                                style={{ fontSize: '12px', fontWeight: '700', color: '#414D55' }}
                                                                            >
                                                                                {leads?.lead?.first_name} {leads?.lead?.last_name}
                                                                            </Typography>
                                                                            <Typography
                                                                                style={{ fontSize: '10px', height: 'auto', marginTop: '0px' }}
                                                                                color="text.secondary"
                                                                            >
                                                                                Assigned to: {leads?.assignto?.name} {leads?.assignto?.last_name}
                                                                            </Typography>

                                                                            <div style={{ display: 'flex', gap: '5px' }}>
                                                                                <div
                                                                                    style={{
                                                                                        borderRadius: '7px',
                                                                                        width: 'auto',
                                                                                        display: 'flex',
                                                                                        gap: '2px',
                                                                                        marginRight: '-14px',
                                                                                        height: 'auto',
                                                                                        padding: '4px',
                                                                                        color: statusDisplay[leads?.lead?.status]?.color,
                                                                                        border: (statusDisplay[leads?.lead?.status] || {}).border,
                                                                                        background: (statusDisplay[leads?.lead?.status] || {})
                                                                                            .background,
                                                                                    }}
                                                                                >
                                                                                    <div style={{ marginTop: '-3px', cursor: 'pointer' }}>
                                                                                        <span style={{ fontSize: '12px' }}>
                                                                                            {(statusDisplay[leads?.lead?.status] || {}).text ||
                                                                                                leads?.lead?.status}
                                                                                        </span>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </CardContent>
                                                                    </CardActionArea>
                                                                </Card>
                                                            </CardContent>
                                                        ))
                                                    ) : (
                                                        <></>
                                                    )}
                                                </Box>
                                            )}
                                        </Box>
                                        <Grid
                                            container
                                            spacing={2}
                                            style={{ marginLeft: '1px', marginBottom: '10px', display: 'flex', justifyContent: 'center' }}
                                        >
                                            {assignmentDetails?.length > 0 ? (
                                                assignmentDetails?.map((leads, index) => (
                                                    <div key={index} onClick={() => handleNavigateLeadDetailsPage(leads?.lead_id)}>
                                                        <Grid item xs={6} md={3} lg={3}>
                                                            <Collapse in={expandedAssignment} timeout="auto" unmountOnExit>
                                                                <CardContent>
                                                                    <Card
                                                                        sx={{ width: 193, height: 232 }}
                                                                        style={{
                                                                            transform: 'scale(1)',
                                                                            transition: 'transform 0.3s ease-in-out',
                                                                            borderRadius: '22px',
                                                                            boxShadow: 'rgba(99, 99, 99, 0.2) 0px 2px 8px 0px',
                                                                        }}
                                                                        onMouseEnter={(e) => (e.currentTarget.style.transform = 'scale(1.05)')}
                                                                        onMouseLeave={(e) => (e.currentTarget.style.transform = 'scale(1)')}
                                                                        key={index}
                                                                    >
                                                                        <CardActionArea>
                                                                            <div style={{ position: 'relative' }}>
                                                                                <div
                                                                                    style={{
                                                                                        position: 'absolute',
                                                                                        top: '53px',
                                                                                        left: '50%',
                                                                                        transform: 'translateX(-50%)',
                                                                                        zIndex: 10,
                                                                                        display: 'flex',
                                                                                        alignItems: 'center',
                                                                                        borderRadius: '4px',
                                                                                        padding: '5px',
                                                                                    }}
                                                                                >
                                                                                    <img
                                                                                        src={logo_between}
                                                                                        alt=""
                                                                                        style={{ width: '44px', height: '44px' }}
                                                                                    />
                                                                                </div>
                                                                            </div>

                                                                            <img
                                                                                src={`https://maps.googleapis.com/maps/api/staticmap?zoom=13&size=450x200&maptype=roadmap&center=${leads?.lead?.buyer_latitude},${leads?.lead?.buyer_longitude}&key=AIzaSyC9saN_UXZFij-RjWWX9drQEQSZw5PaPcA`}
                                                                                alt=""
                                                                                style={{ width: '470px', height: '120px', borderRadius: '10px' }}
                                                                            />

                                                                            <CardContent>
                                                                                <Typography
                                                                                    style={{ fontSize: '12px', fontWeight: '700', color: '#414D55' }}
                                                                                >
                                                                                    {highlightText(
                                                                                        `${leads?.lead?.first_name || ''} ${leads?.lead?.last_name || ''}`,
                                                                                        searchTerm
                                                                                    )}
                                                                                </Typography>
                                                                                <Typography
                                                                                    style={{ fontSize: '10px', height: 'auto', marginTop: '0px' }}
                                                                                    color="text.secondary"
                                                                                >
                                                                                    Assigned to: {leads?.assignto?.name} {leads?.assignto?.last_name}
                                                                                </Typography>

                                                                                <div style={{ display: 'flex', gap: '5px' }}>
                                                                                    <div
                                                                                        style={{
                                                                                            borderRadius: '7px',
                                                                                            width: 'auto',
                                                                                            display: 'flex',
                                                                                            gap: '2px',
                                                                                            marginRight: '-14px',
                                                                                            height: 'auto',
                                                                                            padding: '4px',
                                                                                            color: statusDisplay[leads?.lead?.status]?.color,
                                                                                            border: (statusDisplay[leads?.lead?.status] || {}).border,
                                                                                            background: (statusDisplay[leads?.lead?.status] || {})
                                                                                                .background,
                                                                                        }}
                                                                                    >
                                                                                        <div style={{ marginTop: '-3px', cursor: 'pointer' }}>
                                                                                            <span style={{ fontSize: '12px' }}>
                                                                                                {(statusDisplay[leads?.lead?.status] || {}).text ||
                                                                                                    leads?.lead?.status}
                                                                                            </span>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            </CardContent>
                                                                        </CardActionArea>
                                                                    </Card>
                                                                </CardContent>
                                                            </Collapse>
                                                        </Grid>
                                                    </div>
                                                ))
                                            ) : (
                                                <>
                                                    <Grid
                                                        container
                                                        spacing={2}
                                                        style={{ justifyContent: 'center', alignItems: 'center', marginTop: '20px' }}
                                                    >
                                                        <CardContent>
                                                            <Typography style={{ fontWeight: 'bold', textAlign: 'center' }}>
                                                                No records found!
                                                            </Typography>
                                                        </CardContent>
                                                    </Grid>
                                                </>
                                            )}
                                        </Grid>
                                        {assignmentDetails?.length === 0 ? null : (
                                            <Box style={{ marginBottom: '10px' }}>
                                                {expandedAssignment === true && (
                                                    <Pagination
                                                        count={totalPages}
                                                        color="primary"
                                                        page={currentPage}
                                                        onChange={(event, value) => setCurrentPage(value)}
                                                    // onChange={(event, page) => getAllAssignments(id, page, searchTerm)}
                                                    />
                                                )}
                                            </Box>
                                        )}
                                    </Card>
                                </>
                            )}
                        </ScrollAnimation>
                        <ScrollAnimation animateIn="fadeIn">
                            <Box className={classes.fromToDateIcaAgentDetailsStyles}>
                                <Box>
                                    <div>
                                        <Typography sx={{ fontWeight: 'bold' }}>From</Typography>
                                    </div>
                                    <div>
                                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                                            <DemoContainer components={['DatePicker', 'DesktopDatePicker']}>
                                                <DesktopDatePicker
                                                    sx={{
                                                        width: '320px',
                                                        overflow: 'hidden',
                                                        '.MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
                                                            borderColor: '#c1c1c1',
                                                        },
                                                        '.MuiOutlinedInput-root.Mui-error .MuiOutlinedInput-notchedOutline': {
                                                            borderColor: '#c1c1c1',
                                                        },'& .MuiOutlinedInput-root': {
                                                            borderRadius: '12px',
                                                        },
                                                    }}
                                                    value={fromDate}
                                                    onChange={(newDate) => setFromDate(newDate)}
                                                />
                                            </DemoContainer>
                                        </LocalizationProvider>
                                    </div>
                                </Box>

                                <Box>
                                    <div>
                                        <Typography sx={{ fontWeight: 'bold' }}>To</Typography>
                                    </div>
                                    <div>
                                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                                            <DemoContainer components={['DatePicker', 'DesktopDatePicker']}>
                                                <DesktopDatePicker
                                                    sx={{
                                                        width: '320px',
                                                        overflow: 'hidden',
                                                        '.MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
                                                            borderColor: '#c1c1c1',
                                                        },
                                                        '.MuiOutlinedInput-root.Mui-error .MuiOutlinedInput-notchedOutline': {
                                                            borderColor: '#c1c1c1',
                                                        },'& .MuiOutlinedInput-root': {
                                                            borderRadius: '12px',
                                                        },
                                                    }}
                                                    value={toDate}
                                                    onChange={(newDate) => setToDate(newDate)}
                                                />
                                            </DemoContainer>
                                        </LocalizationProvider>
                                    </div>
                                </Box>

                                <div style={{ marginTop: '25px' }}>
                                    <Box
                                        style={{
                                            width: '56px',
                                            height: '50px',
                                            background: '#336a93',
                                            cursor: 'pointer',
                                            borderRadius: '10px',
                                            marginTop: '6px',
                                            display: 'flex',
                                            justifyContent: 'center',
                                            alignItems: 'center',
                                        }}
                                        onClick={handleSearchClick}
                                    >
                                        {loading ? (
                                            <CircularProgress sx={{ color: 'white' }} />
                                        ) : (
                                            <SearchIcon
                                                style={{
                                                    color: 'white',
                                                    margin: '12px',
                                                    fontSize: '41px',
                                                    cursor: 'pointer',
                                                }}
                                            />
                                        )}
                                    </Box>
                                    <Button
                                        style={{
                                            width: '30px',
                                            height: '35px',
                                            border: '1px solid gray',
                                            background: '#bababa',
                                            borderRadius: '12px',
                                            fontWeight: 'bold',
                                            marginLeft: '0px',
                                            cursor: 'pointer',
                                            marginTop: '5px',
                                            color: 'black',
                                        }}
                                        sx={{ fontFamily: 'inherit' }}
                                        onClick={clearState}
                                    >
                                        clear
                                    </Button>
                                </div>
                            </Box>
                        </ScrollAnimation>

                        <ScrollAnimation animateIn="fadeIn">
                            <Box className={classes.chartRefIcaAgentDetailsStyles}>
                                <canvas ref={chartRef}></canvas>
                            </Box>
                        </ScrollAnimation>
                        
                <ScrollAnimation animateIn='fadeIn'>
                    <Grid container spacing={0} sx={{ marginBottom: '30px' }}>
                        <Grid item xs={12} sm={12} md={6} sx={{ marginTop: '40px' }}>
                            <ScrollAnimation animateIn="fadeIn">
                                <Box
                                    height={490}
                                    style={{
                                        background: '#FFFFFF',
                                        borderRadius: '22px',
                                        boxShadow: 'rgba(99, 99, 99, 0.2) 0px 2px 8px 0px',
                                    }}
                                >
                                    <canvas ref={chartRefPai}></canvas>
                                </Box>
                            </ScrollAnimation>
                        </Grid>
                        <Grid
                            item
                            xs={12}
                            sm={12}
                            md={6}
                            sx={{ marginTop: '40px' }}
                        >
                            <Box
                                height={490}
                                sx={{
                                    background: '#FFFFFF',
                                    borderRadius: '22px',
                                    boxShadow: 'rgba(99, 99, 99, 0.2) 0px 2px 8px 0px',
                                    margin: {
                                        md: '0px 20px',
                                    },
                                    marginRight: {
                                        md: '0px'
                                    },
                                    overflowX: 'auto'
                                }}
                            >
                                <h3 style={{ padding: '25px', paddingBottom: '0px', fontSize: '22px', fontWeight: 'bold', color: '#6D6D6D' }}>
                                    Status Overview
                                </h3>
                                <div style={{padding:'20px'}}>
                                            <Grid container spacing={2}>
                                                {paiChartData?.map((status, index) => {
                                                    const statusColor = circleProgressColors[status.status] || 'gray';
                                                    const statusLabel = statusLabelColors[status.status] || 'gray';
                                                    const statusImage = statusImages[status.status] || null;
                                                    return (
                                                        <Grid item xs={12} sm={6} md={4} lg={3} key={index}>
                                                            <Card
                                                                style={{
                                                                    padding: '10px',
                                                                    border: '1px solid #ccc',
                                                                    borderRadius: '18px',
                                                                    boxShadow: 'rgba(99, 99, 99, 0.2) 0px 2px 8px 0px',
                                                                    textAlign: 'center',
                                                                    cursor: 'pointer',
                                                                    transform: 'scale(1)',
                                                                    transition: 'transform 0.3s ease-in-out',
                                                                    background:'#FBFBFB',
                                                                }}
                                                                onMouseEnter={(e) => (e.currentTarget.style.transform = 'scale(1.05)')}
                                                                onMouseLeave={(e) => (e.currentTarget.style.transform = 'scale(1)')}
                                                            >
                                                                <div style={{ display: 'flex' }}>
                                                                    <div>
                                                                    <Avatar
                                                                    alt="AI"
                                                                    src={statusImage}
                                                                />
                                                                    </div>
                                                                    <div style={{ width: 100, height: 100, margin: 'auto' }}>
                                                                        <CircularProgressbar
                                                                            value={percentages[index]}
                                                                            text={`${percentages[index]}%`}
                                                                            styles={buildStyles({
                                                                                textColor: statusLabel,
                                                                                pathColor: statusColor,
                                                                                textSize: '16px',
                                                                                fontWeight:'bold',
                                                                                pathTransitionDuration: 0.5,
                                                                            })}
                                                                            strokeWidth={'14'}
                                                                        />
                                                                    </div>
                                                                </div>
                                                                <Box style={{display: 'grid', justifyContent: 'flex-start', marginTop: '5px' }}>
                                                                    <Box style={{display:'flex',justifyContent:'flex-start'}}>
                                                                        <Typography style={{ fontSize: '14px', fontWeight: 'bold', color: statusLabel }}>
                                                                            {status.status}
                                                                        </Typography>
                                                                    </Box>
                                                                    <Box style={{display:'flex',justifyContent:'flex-start',marginTop:'5px'}}>
                                                                        <div>
                                                                        <Typography style={{ fontSize: '14px', color: '#898484' }}>Number Count:</Typography>
                                                                        </div>
                                                                        <div style={{display:'flex'}}>
                                                                        <Typography style={{ fontSize: '12px', color: '#605e5e',marginLeft:'20px', fontWeight:'bold' }}>
                                                                            {status.status_count}
                                                                        </Typography>
                                                                        </div>
                                                                    </Box>
                                                                </Box>
                                                            </Card>
                                                        </Grid>
                                                    );
                                                })}
                                            </Grid>
                                        </div>
                            </Box>
                        </Grid>
                    </Grid>
                </ScrollAnimation>

                    </ScrollAnimation>
                </ThemeProvider>
            </Container>
        </>
    );
};

export default ISAAgentsDetails;
